import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { colorCombinations } from 'utils/colors';

import { faCircle } from '@fortawesome/pro-solid-svg-icons';

import * as S from './styled/CustomChartLegend.styled';

const Legend = ({
	data,
	legendPlacement = 'bottom',
	minWidth,
	placeItems = 'vertical',
	showAmount = 'true',
	withCurrency,
	currency,
	customColors,
	showColumnsTitle = false,
	column1Title,
	column2Title
}) => {
	const sortedData = data?.labels
		.map((label, index) => ({
			label,
			value: data?.datasets?.[0]?.data?.[index] || 0,
			color: customColors?.[index]?.color || colorCombinations?.[index]?.color
		}))
		.sort((a, b) => b.value - a.value);

	return (
		<S.Legend legendPlacement={legendPlacement} minWidth={minWidth} placeItems={placeItems}>
			{showColumnsTitle && (
				<S.LegendHeaderLine>
					<Typography noWrap color={'var(--content-3)'}>
						{column1Title}
					</Typography>
					<Typography noWrap className="text-end" color={'var(--content-3)'}>
						{column2Title}
					</Typography>
				</S.LegendHeaderLine>
			)}
			{sortedData?.map(({ label, value, color }, index) => (
				<S.LegendItem key={index} placeItems={placeItems}>
					<S.LegendEntryTitle>
						<Icon icon={faCircle} color={color} />
						<Typography noWrap color={'var(--content-3)'}>
							{label}
						</Typography>
					</S.LegendEntryTitle>
					{showAmount && (
						<Typography
							variant="p3"
							className="text-end"
							noWrap
							fontWeight="700"
							withCurrency={withCurrency}
							currency={currency}>
							{value}
						</Typography>
					)}
				</S.LegendItem>
			))}
		</S.Legend>
	);
};

export default Legend;
